import { restApi } from '../../api/restApiSlice';

export const packageApiSlice = restApi.injectEndpoints({
  endpoints: (builder) => ({
    getPackages: builder.query({
      query: () => '/v3/packages',
    }),
  }),
});

export const { useGetPackagesQuery } = packageApiSlice;
